<template :key="$route.name">
<!--  serviceman list-->
  <base-table-wrapper v-if="$route.name === 'ServicemenList'">
    <template #top-buttons>
      <router-link
        v-if="ableToCreateServiceman"
        :to="{ name: 'ServicemenCreate' }"
        class="mb-1 btn btn-sm btn-primary float-right"
      >
        {{ $t('buttons.create') }}
      </router-link>
    </template>
    <template #filtering>
      <div>
        <button
          type="button"
          class="btn btn-sm btn-primary fa fa-filter float-right"
          v-b-tooltip.hover :title="$t('buttons.search')"
          v-b-toggle.servicemen_search_collapse>
        </button>
      </div>
      <div>
          <b-collapse id="servicemen_search_collapse" class="mt-2">
            <ServicemenFiltering @addToSearchParams="setSearchParamsServicemen($event)"></ServicemenFiltering>
          </b-collapse>
      </div>
    </template>
    <template #body>
      <Table
        @selectedUsers="updateSelectedUsers($event)"
        :search-url="searchUrl"
        :search-params="searchParamsServicemen"
      >
        <template v-slot:default="item">
          <div class="btn-group float-right">
            <router-link
              tag="button"
              class="btn btn-sm btn-link fa fa-search fa-lg"
              v-b-tooltip.hover :title="$t('buttons.show')"
              :to="{name: 'ServicemenShow', params: { id: item.item['@id'] }}">
            </router-link>
            <router-link
              tag="button"
              class="btn btn-sm btn-link fa fa-edit fa-lg"
              v-b-tooltip.hover :title="$t('buttons.edit')"
              :to="{name: 'ServicemenUpdate', params: { id: item.item['@id'] }}">
            </router-link>
          </div>
        </template>
      </Table>
    </template>
  </base-table-wrapper>
<!--  userdata list-->
  <base-table-wrapper v-else>
    <template #top-buttons>
      <router-link
        v-if="ableToCreateUserData"
        :to="{ name: 'UserDataCreate' }"
        class="mb-1 btn btn-sm btn-primary float-right"
      >
        {{ $t('buttons.create') }}
      </router-link>
    </template>
    <template #filtering>
      <div>
        <button
          type="button"
          class="btn btn-sm btn-primary fa fa-filter float-right"
          v-b-tooltip.hover :title="$t('buttons.search')"
          v-b-toggle.userdata_search_collapse>
        </button>
      </div>
      <div>
        <b-collapse id="userdata_search_collapse">
          <UserDataFiltering class="mx-1" @addToSearchParams="setSearchParamsUserData($event)"></UserDataFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <Table
        ref="table"
        @selectedUsers="updateSelectedUsers($event)"
        :search-url="searchUrl"
        :search-params="searchParamsUserData"
      >
        <template v-slot:default="item">
          <div class="btn-group float-right">
            <router-link
              tag="button"
              class="btn btn-sm btn-link fa fa-search fa-lg"
              v-b-tooltip.hover :title="$t('buttons.show')"
              :to="{name: 'UserDataShow', params: { id: item.item['@id'] }}">
            </router-link>
            <router-link
              tag="button"
              class="btn btn-sm btn-link fa fa-edit fa-lg"
              v-b-tooltip.hover :title="$t('buttons.edit')"
              :to="{name: 'UserDataUpdate', params: { id: item.item['@id'] }}">
            </router-link>
            <b-dropdown
              v-if="ableToManageUsers"
              class="float-right"
              size="sm" variant="link"
              right text="Right align"
              toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="fa fa-bars fa-lg"></i>
              </template>
             <b-dropdown-item
                @click="anonymize(item.item['@id'])">
                <i class="fa fa-key fa-lg"></i>
                {{ $t('buttons.anonymize') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </Table>
      <b-dropdown size="sm" variant="warning" dropright text="Drop-Right">
        <template #button-content>
          {{ $t('buttons.collectionOperations') }}
        </template>
        <b-dropdown-item @click="addMultipleUsers()"><i class="fa fa-file-check mr-2"></i>{{$t('views.userdata.list.addMultipleUsers')}}</b-dropdown-item>
        <b-dropdown-item v-if="$store.getters['configuration/mailerLiteStatus']" @click="addToMailerLite()"><i class="fa fa-file-check mr-2"></i>{{$t('views.userdata.list.autoAddMailerLiteSubscribers')}}</b-dropdown-item>
      </b-dropdown>
      <userDataAddToMailerLiteModal v-if="$store.getters['configuration/mailerLiteStatus']"></userDataAddToMailerLiteModal>
    </template>
  </base-table-wrapper>
</template>

<script>
import { checkPermission } from '@/utils/checkRoles'
import ServicemenFiltering from './component/ServicemenFiltering/ServicemenFiltering'
import UserDataFiltering from './component/UserDataFiltering/UserDataFiltering'
import getId from '@/utils/getIdFromLink'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Table from './Table'
import ApiService from '@/utils/ApiService'
import userDataAddToMailerLiteModal from '@/components/Dashboard/Views/userdata/component/MailerLite/userDataAddToMailerLiteModal'

export default {
  components: {
    userDataAddToMailerLiteModal,
    ServicemenFiltering,
    UserDataFiltering,
    BaseTableWrapper,
    Table
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ableToCreateServiceman () {
      return checkPermission('servicemen', 'ServicemenCreate')
    },
    ableToCreateClient () {
      return checkPermission('firms', 'ClientCreate')
    },
    ableToCreateUserData () {
      return checkPermission('userdatas', 'UserDataCreate')
    },
    ableToManageUsers () {
      return checkPermission('appConfiguration', 'AppConfiguration')
    }
  },

  watch: {
    searchParamsUserData: {
      deep: true,
      handler () {
        this.$forceUpdate()
      }
    }
  },

  beforeCreate () {
  },

  data () {
    return {
      routeName: '',
      searchParamsUserData: {
        isCompany: 0,
        state: 1,
        idClientType: ''
      },
      searchParamsServicemen: {
        'isCompany': 0,
        'idClientType': 5,
        state: 1
      },
      searchUrl: '',
      selectedUsers: []
    }
  },

  methods: {
    setSearchParamsUserData (params = {}) {
      let searchParams = {}
      Object.assign(searchParams, this.searchParamsUserData)
      Object.assign(searchParams, params)
      this.searchParamsUserData = searchParams
    },

    setSearchParamsServicemen (params) {
      let searchParams = {}
      Object.assign(searchParams, this.searchParamsServicemen)
      Object.assign(searchParams, params)
      this.searchParamsServicemen = searchParams
    },
    getIdLink (link) {
      return getId(link)
    },
    updateSelectedUsers (val) {
      this.selectedUsers = val
    },
    async anonymize (id) {
      const decision = await this.$Swal({
        title: this.$t('views.userdata.list.anonymize'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      })
      if (decision) {
        await new ApiService('user_datas/' + getId(id) + '/anonymisation').post({})
      }
    },
    async addMultipleUsers () {
      const decision = await this.$Swal({
        title: this.$t('views.userdata.list.addMultipleUsersQuestion'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      })
      if (decision) {
        let users = this.selectedUsers.map(entry => {
          return getId(entry)
        })
        await new ApiService('user_datas/add_user_multi').post({ users: users })
      }
    },
    addToMailerLite () {
      let users = this.selectedUsers.map(entry => {
        return getId(entry)
      })
      this.$store.state.modals.userdata.addToMailerLite = { show: 1, selectedUsers: users }
    }
  }
}
</script>
